<template>
  <div class="articles-page">
    <h1>{{ $t('articles.title') }}</h1>
    <div class="articles-grid">
      <router-link 
        v-for="article in localizedArticles" 
        :key="article.id"
        :to="article.path"
        class="article-card"
      >
        <img :src="article.image" :alt="article.title">
        <div class="article-info">
          <h2>{{ article.title }}</h2>
          <p class="article-date">{{ formatDate(article.publicationDate) }}</p>
          <p class="article-description">{{ article.description }}</p>
        </div>
      </router-link>
    </div>
  </div>
</template>

<script>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { articles } from '@/data/articles'

export default {
  name: 'Articles',
  setup() {
    const { locale } = useI18n()

    const localizedArticles = computed(() => {
      return articles.map(article => ({
        ...article,
        title: article.titles[locale.value] || article.titles['de'],
        description: article.descriptions[locale.value] || article.descriptions['de'],
        publicationDate: new Date(article.publicationDate)
      }))
    })

    return {
      localizedArticles,
      formatDate: (date) => {
        return new Intl.DateTimeFormat(locale.value, {
          year: 'numeric',
          month: 'long',
          day: 'numeric'
        }).format(date)
      }
    }
  }
}
</script>

<style scoped>
.articles-page {
  padding: 2rem;
  max-width: 1200px;
  margin: 0 auto;
}

.articles-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 2rem;
  margin-top: 2rem;
}

.article-card {
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease;
  text-decoration: none;
  color: inherit;
  background: white;
}

.article-card:hover {
  transform: translateY(-4px);
}

.article-card img {
  width: 100%;
  height: 200px;
  object-fit: cover;
}

.article-info {
  padding: 1.5rem;
}

.article-info h2 {
  margin: 0 0 0.5rem 0;
  color: var(--text-primary);
  font-size: var(--font-size-h5);
  font-weight: var(--font-weight-semibold);
}

.article-date {
  color: var(--text-muted);
  font-size: var(--font-size-body-2);
  font-weight: var(--font-weight-medium);
  margin-bottom: 0.5rem;
}

.article-description {
  color: var(--text-secondary);
  line-height: var(--line-height-relaxed);
}
</style> 
